import { useDispatch } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import { LoadingModal } from './component/modal/modal';
import useWindowSize from './hook/useWindowSize';

function UrlDetail() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true);

    // ===== 목업 데이터 =====
    const mockProduct = useMemo(
        () => ({
            title:
                '[100% NFC 토마토 14개 착즙] 보넬드 아이엠 토마토 주스 즙 원액 1L, 3개',
            brand: '보넬드',
            modelName: '아이엠 토마토 1L',
            origin: '베트남',
            rating: 4.77,
            recentRating: 4.76,
            reviewCount: 88,
            listPrice: 26900,
            salePrice: 23900,
            myPrice: 16900,
            unitPriceText: '(100ml당 563원)',
            freeShipping: true,
            deliveryText: '오늘배송 · 오늘 도착',
            benefitText: '최대 적립 포인트 3,366원 · 멤버십 추가 적립',
            heroImages: ['https://picsum.photos/id/1080/1200/900'], // 대표이미지 1장
            detailImages: [
                'https://picsum.photos/id/1060/1200/1800',
                'https://picsum.photos/id/1069/1200/1800',
                'https://picsum.photos/id/1043/1200/1800',
            ],
            quantityChoices: [1], // 수량 1개만
        }),
        []
    );

    // ===== 상태 =====
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [sheetOpen, setSheetOpen] = useState(false); // 바텀시트
    const [qty, setQty] = useState(1);                 // ✅ 모달 수량
    const MIN_QTY = 1;
    const MAX_QTY = 99;

    const unitPrice = mockProduct.myPrice || mockProduct.salePrice;
    const totalAmount = unitPrice * qty;

    const discountRate = useMemo(() => {
        if (!mockProduct.listPrice || !mockProduct.salePrice) return null;
        return Math.round((1 - mockProduct.salePrice / mockProduct.listPrice) * 100);
    }, [mockProduct]);

    const fmt = (n) => (typeof n === 'number' ? n.toLocaleString('ko-KR') : n);

    useEffect(() => {
        dispatch(change_Current_Location('URL상품상세'));
        dispatch(changeHeaderTitle({ mainTitle: 'URL상품상세', subTitle: '' }));
        setTimeout(() => setLoading(false), 300);
    }, []);

    useEffect(() => {
        if (sheetOpen) {
            const prev = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            return () => (document.body.style.overflow = prev);
        }
    }, [sheetOpen]);

    const handleBuyClick = () => setSheetOpen(true);

    const handleConfirmBuy = () => {
        const payload = {
            product: { ...mockProduct },       // 상품 전체 정보
            quantity: qty,                     // 수량
            unitPrice,                         // 단가(할인가 우선)
            amount: totalAmount,               // 총 결제 금액
        };
        setSheetOpen(false);
        navigate('/urlPayment', { state: payload });
    };

    const decQty = () => setQty((v) => Math.max(MIN_QTY, v - 1));
    const incQty = () => setQty((v) => Math.min(MAX_QTY, v + 1));

    return (
        <>
            {loading ? <LoadingModal /> : ''}
            <div style={{ background: '#fff', minHeight: "100dvh" }}>
                {/* ===== 상세페이지 시작 ===== */}
                <div className="urlDetail-wrap">
                    {/* 상단 대표 이미지 (1장) */}
                    <section className="urlDetail-hero">
                        <img className="urlDetail-heroImg" src={mockProduct.heroImages[0]} alt={mockProduct.title} />
                    </section>

                    {/* 타이틀 & 평점 */}
                    <section className="urlDetail-titleBox">
                        <h1 className="urlDetail-title">
                            {mockProduct.title}
                            {mockProduct.origin && <span className="urlDetail-origin"> [원산지:{mockProduct.origin}]</span>}
                        </h1>
                        {/* <div className="urlDetail-ratingLine">
                            <span className="urlDetail-star">★</span>
                            <span className="urlDetail-rating">{mockProduct.rating.toFixed(2)}</span>
                            <span className="urlDetail-recent"> (최근 6개월 {mockProduct.recentRating.toFixed(2)})</span>
                            <span className="urlDetail-reviews"> · {fmt(mockProduct.reviewCount)}건 리뷰</span>
                        </div> */}
                    </section>

                    {/* 가격 */}
                    <section className="urlDetail-priceBox">
                        <div className="urlDetail-priceRow urlDetail-priceRow--strike">
                            {discountRate !== null && <strong className="urlDetail-discount">{discountRate}%</strong>}
                            <span className="urlDetail-listPrice">{fmt(mockProduct.listPrice)}원</span>
                        </div>
                        <div className="urlDetail-priceRow">
                            <strong className="urlDetail-salePrice">{fmt(mockProduct.salePrice)}원</strong>
                        </div>
                        {/* <div className="urlDetail-myPrice">
                            <strong>{fmt(mockProduct.myPrice)}원</strong> <span>나의 할인가</span>
                        </div> */}
                        <div className="urlDetail-shipLine">
                            {mockProduct.freeShipping && <span className="urlDetail-freeShip">무료배송</span>}
                            {/* {mockProduct.unitPriceText && <span className="urlDetail-unit">{mockProduct.unitPriceText}</span>} */}
                        </div>
                    </section>

                    {/* 혜택 + 배송(원복) */}
                    <section className="urlDetail-benefitWrap">
                        {mockProduct.benefitText && <div className="urlDetail-benefit">{mockProduct.benefitText}</div>}
                        {mockProduct.deliveryText && (
                            <div className="urlDetail-delivery">
                                <span className="urlDetail-nologo">🚚</span>
                                {mockProduct.deliveryText}
                            </div>
                        )}
                    </section>

                    {/* 탭 – 상세정보만 (밑줄: border-bottom) */}
                    <nav className="urlDetail-tabs" role="tablist" aria-label="상품 탭">
                        <span className="urlDetail-tab is-active" role="tab" aria-selected="true">상세정보</span>
                    </nav>

                    {/* 상세정보 – 상품정보 → 이미지 → 토글 */}
                    <section className={'urlDetail-detailBody ' + (detailsOpen ? 'is-open' : 'is-closed')}>
                        <div className="urlDetail-detailInner">
                            <div className="urlDetail-spec urlDetail-spec--inDetail">
                                <h2 className="urlDetail-specTitle">상품정보</h2>
                                <dl className="urlDetail-specTable">
                                    <dt>브랜드</dt><dd>{mockProduct.brand}</dd>
                                    <dt>모델명</dt><dd>{mockProduct.modelName}</dd>
                                    <dt>원산지</dt><dd>{mockProduct.origin}</dd>
                                </dl>
                            </div>

                            {mockProduct.detailImages.map((src, i) => (
                                <img className="urlDetail-detailImg" src={src} alt={`상세이미지 ${i + 1}`} key={i} />
                            ))}
                        </div>

                        {!detailsOpen && <div className="urlDetail-detailFade" aria-hidden="true" />}

                        <button
                            className="urlDetail-detailToggle"
                            onClick={() => setDetailsOpen((v) => !v)}
                            aria-expanded={detailsOpen}
                        >
                            <span className="urlDetail-toggleText">{detailsOpen ? '접기' : '상세정보 펼쳐보기'}</span>
                            <svg width="18" height="18" viewBox="0 0 24 24"
                                className={'urlDetail-toggleIcon ' + (detailsOpen ? 'is-open' : '')}
                                aria-hidden="true">
                                <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </section>

                    {/* 하단 고정 – 결제하기(#0b3a6f) */}
                    <div className="urlDetail-bottomPad" />
                    <div className="urlDetail-buybar urlDetail-buybar--single">
                        <button className="urlDetail-buyBtn" onClick={handleBuyClick}>결제하기</button>
                    </div>

                    {/* ===== 바텀시트 모달 ===== */}
                    <div className={'urlDetail-sheet ' + (sheetOpen ? 'is-open' : '')}
                        role="dialog" aria-modal="true" aria-label="결제 확인">
                        <div className="urlDetail-sheetDim" onClick={() => setSheetOpen(false)} />
                        <div className="urlDetail-sheetPanel">
                            <div className="urlDetail-sheetHandle" />

                            {/* 카드 영역 */}
                            <div className="urlDetail-payCard">
                                <div className="urlDetail-payHeader">
                                    <div className="urlDetail-payText">
                                        <strong className="urlDetail-payTitle urlDetail-ellipsis">{mockProduct.title}</strong>
                                    </div>
                                </div>
                            </div>

                            {/* ✅ 수량 스텝퍼 + 요약 */}
                            <div className="urlDetail-qtyCard">
                                <div className="urlDetail-qtyRow">
                                    <div className="urlDetail-qtyTitle">수량선택</div>
                                    <div className="urlDetail-stepper" aria-label="수량 선택">
                                        <button
                                            className="urlDetail-stepBtn"
                                            onClick={decQty}
                                            disabled={qty <= MIN_QTY}
                                            aria-label="감소"
                                            type="button"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 24 24">
                                                <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </button>
                                        <div className="urlDetail-stepValue">{qty}</div>
                                        <button
                                            className="urlDetail-stepBtn"
                                            onClick={incQty}
                                            disabled={qty >= MAX_QTY}
                                            aria-label="증가"
                                            type="button"
                                        >
                                            <svg width="16" height="16" viewBox="0 0 24 24">
                                                <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div className="urlDetail-qtySummary">
                                    <div>총 수량 <b className="urlDetail-accent">{qty}</b>개</div>
                                    <div>총 금액 <b className="urlDetail-accent">{fmt(totalAmount)}</b>원</div>
                                </div>
                            </div>

                            {/* 총 결제 금액 */}
                            {/* <div className="urlDetail-totalRow">
                <span>총 결제 금액</span>
                <strong className="urlDetail-total">{fmt(totalAmount)}원</strong>
              </div> */}

                            {/* 하단 버튼(상단과 동일 스타일) */}
                            <div className="urlDetail-sheetBuybar">
                                <button className="urlDetail-buyBtn" onClick={handleConfirmBuy}>결제하기</button>
                            </div>
                        </div>
                    </div>
                    {/* ===== 바텀시트 끝 ===== */}
                </div>
                {/* ===== 상세페이지 끝 ===== */}
            </div>
        </>
    );
}

export default UrlDetail;
